import React from 'react';

export const recalls = [
  { name: '✅ Yes on Recall Alison Collins' },
  { name: '✅ Yes on Recall Gabriela López' },
  { name: '✅ Yes on Recall Faauuga Moliga' },
];

export const assessor = [
  {
    name: 'Joaquín Torres',
    title: 'Assessor-Recorder',
  },
];

export const assembly = [
  {
    name: 'Bilal Mahmood',
    title: 'Assembly, District 17',
  },
];

export const assemblyCandidates = {
  contest: 'Assembly, District 17',
  candidates: [
    {
      name: 'Bilal Mahmood',
      endorsed: true,
      bio: 'Entrepreneur',
      questionnaire: '/voter-guide/questionnaires/feb-2022/bilal-mahmood',
    },
    {
      name: 'Matt Haney',
      bio: 'Supervisor, District 6',
      questionnaire: '/voter-guide/questionnaires/june-2022/matt-haney',
    },
    {
      name: 'David Campos',
      bio: 'Chief of Staff to District Attorney Chesa Boudin, Former Supervisor of District 9',
    },
    {
      name: 'Thea Selby',
      bio: 'San Francisco Community College Board member',
    },
  ],
};
